import { useCallback } from "react";
import {
  NavigateOptions,
  useNavigate,
  useOutletContext,
} from "react-router-dom";

/**
 * When rendered under `/admin/platform/*`, prefixes absolute app paths so
 * navigation stays inside Community Admin. Outside that tree, behaves like useNavigate.
 */
export function useAppNavigate() {
  const navigate = useNavigate();
  const base = useOutletContext<string | undefined>() ?? "";

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === "number") {
        navigate(to);
        return;
      }
      if (!base) {
        navigate(to, options);
        return;
      }
      if (to.startsWith(base)) {
        navigate(to, options);
        return;
      }
      if (!to.startsWith("/")) {
        navigate(to, options);
        return;
      }
      const suffix = to === "/" ? "" : to;
      navigate(`${base}${suffix}`, options);
    },
    [base, navigate]
  );
}
